export function timeLabel(ts) {
  return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function dayLabel(ts) {
  const d = new Date(ts);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return 'Today';
  const yesterday = new Date(today.getTime() - 86400000);
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday';
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

// Places arrive from two sources — the reverse lookup names the country, the
// offline IP database only gives an ISO code. Spell codes out so a line reads
// "joined from Berlin, Germany" whichever one got there first.
const REGIONS = (() => {
  try { return new Intl.DisplayNames(['en'], { type: 'region' }); } catch { return null; }
})();

export function countryName(country) {
  const code = String(country ?? '').trim();
  if (!/^[A-Za-z]{2}$/.test(code)) return code;
  try { return REGIONS?.of(code.toUpperCase()) || code.toUpperCase(); } catch { return code.toUpperCase(); }
}

/**
 * "Paris, France", or '' while the reverse lookup is still out — empty means
 * there is nothing worth saying yet, so callers can leave the phrase off.
 */
export function placeName(actor) {
  if (!actor || actor.locationSource === 'fallback') return '';
  return [actor.city, countryName(actor.country)].filter(Boolean).join(', ');
}

export function placeLabel(actor) {
  if (actor.locationSource === 'fallback') return 'location unavailable';
  const named = placeName(actor);
  if (named) return named;
  // A place name is always on its way — the reverse lookup broadcasts an
  // update the moment it lands, so hold the space rather than show raw numbers.
  return 'locating…';
}

/** "just now", "4m ago", "2h ago" — for the activity feed. */
export function sinceLabel(ts) {
  const secs = Math.max(0, Math.round((Date.now() - ts) / 1000));
  if (secs < 45) return 'just now';
  if (secs < 3600) return `${Math.round(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.round(secs / 3600)}h ago`;
  return `${Math.round(secs / 86400)}d ago`;
}

/**
 * The three post modes, in the product's own words. The rail, the feed and the
 * map card all say the same thing, so they all read it from here.
 */
export const MODE_LABEL = { offering: 'offering', looking: 'looking for', happening: 'happening' };

/** "Sat, 14 Mar, 14:00" — when something is due to happen. */
export function whenLabel(ms) {
  return new Date(ms).toLocaleString([], {
    weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

/** Black or white ink, whichever survives on the given swatch. */
export function readableInk(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  if (!m) return '#fff';
  const n = parseInt(m[1], 16);
  const lum = (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  return lum > 0.62 ? '#0b0e1a' : '#fff';
}
